export default {
  // Navigation
  "home": "होम",
  "detailed": "विस्तृत जीवन रिपोर्ट",
  "about": "हमारे बारे में",
  "contact": "संपर्क",
  "get_reading": "रीडिंग प्राप्त करें",
  "unlock_destiny": "अपनी नियति को खोलें",
  "language": "भाषा",
  
  // Core Horoscope
  "core_horoscope": "मुख्य कुंडली",
  "birth_chart": "जन्म कुंडली",
  "match_horoscope": "मैच कुंडली",
  "ascendant_analysis": "लग्न विश्लेषण",
  "gochar_phal": "गोचर फल",
  "dasha_analysis": "दशा फल विश्लेषण",
  "nakshatra_report": "नक्षत्र रिपोर्ट",
  "numerology": "अंकशास्त्र",
  
  // Life Predictions
  "life_predictions": "जीवन भविष्यवाणी",
  "your_life_predictions": "आपकी जीवन भविष्यवाणी",
  "2025_report": "2025 व्यक्तिगत रिपोर्ट",
  "year_analysis": "वार्षिक विश्लेषण",
  "daily_horoscope": "आज का दिन",
  "love_compatibility": "प्रेम अनुकूलता",
  "career_guidance": "करियर मार्गदर्शन",
  "nature_analysis": "प्रकृति विश्लेषण",
  "health_index": "स्वास्थ्य सूचकांक",
  
  // Remedial Solutions
  "remedial_solutions": "उपचारात्मक समाधान",
  "lal_kitab": "लाल किताब कुंडली",
  "mangal_dosha": "मंगल दोष विश्लेषण",
  "kalsarp_dosh": "कालसर्प दोष रिपोर्ट",
  "sade_sati": "साढ़े साती जीवन रिपोर्ट",
  "ask_question": "प्रश्न पूछें",
  "gemstones_report": "रत्न रिपोर्ट"
};
